// extracted by mini-css-extract-plugin
export default {"btn":"UserWidget_btn__QYvwg","span":"UserWidget_span__kYazm","user":"UserWidget_user__aOrZY"};